import FAQ from './Faq';
import Pages from './Pages';
import Guests from './Guests';
import BookGym from './BookGym';
import Payment from './Payment';
import Settings from './Settings';
import Events from './BookEvents';
import CronJobs from './CronJobs';
import MyCompany from './MyCompany';
import BookARoom from './BookARoom';
import QrMapsRoutes from './QrCode';
import Booking from './MyActivities';
import Dashboards from './Dashboards';
import BookALounge from './BookALounge';
import ContactSupport from './ContactSupport';
import Subscriptions from './Subscriptions';
import SupportEvents from './SupportEvents';
import BookARoofTop from './BookARoofTop';

// ** Document title
const TemplateTitle = '%s - Compie React Admin Template';

// ** Default Route
const DefaultRoute = '/dashboards';

// ** Merge Routes
const Routes = [
  ...Pages,
  ...Dashboards,
  ...Booking,
  ...Events,
  ...Guests,
  ...Settings,
  ...ContactSupport,
  ...BookARoom,
  ...BookGym,
  ...BookALounge,
  ...FAQ,
  ...Payment,
  ...MyCompany,
  ...QrMapsRoutes,
  ...Subscriptions,
  ...SupportEvents,
  ...BookARoofTop,
];

export { DefaultRoute, TemplateTitle, Routes };
